import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=dde0f9fa&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dde0f9fa')) {
      api.createRecord('dde0f9fa', component.options)
    } else {
      api.reload('dde0f9fa', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=dde0f9fa&", function () {
      api.rerender('dde0f9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2lxim1T9y6JHr/JS/comp/FavElement.vue"
export default component.exports